import { useConnectionCRUDActions } from '../actions/ConnectionsCRUDActions';
import { shallowEqual, useSelector } from 'react-redux';
import { StoreState } from '../store-interfaces';
import { activeFacebookPageSelector } from '../selectors/facebookPageSelector';
import { activeChatbotSelector } from '../selectors/viewSelectors';
import ConnectionModel from '../model/ConnectionModel';
import { isEqual, omit } from 'lodash';
import { blankVariable } from '../helpers/connection-helpers';

export const useEditConnectionActions = () => {
  const connectionCRUDActions = useConnectionCRUDActions();

  const { facebookPage, chatbot } = useSelector(
    (state: StoreState) => ({
      facebookPage: activeFacebookPageSelector(state),
      chatbot: activeChatbotSelector(state),
    }),
    shallowEqual,
  );

  const updateRemoteConnection = async (connection: ConnectionModel) => {
    if (facebookPage && connection) {
      const variables = connection.variables || [];

      const filteredVariables = variables.filter(variable => {
        if (
          isEqual(
            omit(variable, ['static', 'kind']),
            omit(blankVariable(), ['static', 'kind']),
          )
        ) {
          return false;
        }

        return variable.static ? true : !!variable.name;
      });

      return connectionCRUDActions.update(facebookPage.id, {
        ...connection,
        variables: filteredVariables,
      });
    }
  };

  return {
    updateRemoteConnection,
    facebookPage,
    chatbot,
  };
};
